import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.function.name.js";
import { uploadImage } from "../../unit/UploadImage";
import dsteem from "../../unit/DsteemUtil";
import { extractLoginData } from "../../unit/UserUtil";
export default {
  name: "community-edit",
  props: ["showModel", "community"],
  emits: ["update:community"],
  data: function data() {
    return {
      isShowButton: false,
      loginData: null,
      communities: {},
      imageUrl: ""
    };
  },
  watch: {
    community: function community() {
      this.communities.title = this.community.title;
      this.communities.about = this.community.about;
      this.communities.is_nsfw = this.community.is_nsfw;
      this.communities.lang = this.community.lang;
      this.communities.description = this.community.description;
      this.communities.flag_text = this.community.flag_text;
      this.communities.avatar_url = this.community.avatar_url;
    }
  },
  methods: {
    imgAdd: function imgAdd(params) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _file;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _file = params.file;
                _context.next = 3;
                return uploadImage(_file);

              case 3:
                _this.communities.avatar_url = _context.sent;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    closeModel: function closeModel() {
      this.$emit("closeModel");
    },
    save: function save() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var community, tempCommunities;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                community = _this2.community;
                community.title = _this2.communities.title;
                community.about = _this2.communities.about;
                community.is_nsfw = _this2.communities.is_nsfw;
                community.lang = _this2.communities.lang;
                community.description = _this2.communities.description;
                community.flag_text = _this2.communities.flag_text;
                community.avatar_url = _this2.communities.avatar_url;

                _this2.$emit("update:community", community);

                tempCommunities = _this2.communities;
                tempCommunities.settings = {};
                tempCommunities.settings.avatar_url = _this2.communities.avatar_url;
                tempCommunities.avatar_url = undefined;
                _context2.next = 15;
                return dsteem.saveCommunityInfo(_this2.community.name, tempCommunities);

              case 15:
                _this2.closeModel();

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = file.type === "image/jpeg" || file.type === "image/png";
      var isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }

      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }

      return isJPG && isLt2M;
    }
  },
  mounted: function mounted() {}
};